import script from "./ProductDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductDetails.vue?vue&type=script&setup=true&lang=js"

import "./ProductDetails.vue?vue&type=style&index=0&id=0f24f58f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f24f58f"]])

export default __exports__